import React from 'react'
import IMG1 from '../../assets/ecommerce.png'
import IMG2 from '../../assets/aigyan.jpeg'
import IMG3 from '../../assets/news-summarization.jpg'
import IMG4 from '../../assets/justbooks.png'
import IMG5 from '../../assets/zombie-tank-vs-me.png'
import IMG6 from '../../assets/simple-minds.jpeg'
import IMG7 from '../../assets/agrotrade.jpg'
import IMG8 from '../../assets/weather.png'
import './portfolio.css'

const Portfolio = () => {
  return (
    <section id="portfolio" className='card-container'>
      <h5>My Recent Work</h5>
      <h2>Projects</h2>

      <div className="container portfolio__container">

        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={IMG1} alt="" />
          </div>
          <h3>Fullstack E-commerece webapp</h3>
          <div className="portfolio__item-cta">
            <a href="https://github.com/TejasPatne/IanSabi-Ecommerce" className='btn' target='blank'>Code</a>
            <a href="https://iansabi-website.onrender.com/" className='btn btn-primary' target='blank'>Live Demo</a>
          </div>
        </article>

        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={IMG2} alt="" />
          </div>
          <h3>AiFarming - Modern Agriculture with ML</h3>
          <div className="portfolio__item-cta">
            <a href="https://github.com/TejasPatne/AI-Farming-LBS" className='btn' target='blank'>Code</a>
            <a href="https://github.com/TejasPatne/AI-Farming-LBS" className='btn btn-primary' target='blank'>Live Demo</a>
          </div>
        </article>
        
        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={IMG4} alt="" />
          </div>
          <h3>Justbooks Ebook Library</h3>
          <div className="portfolio__item-cta">
            <a href="https://github.com/TejasPatne/justbooks" className='btn' target='blank'>Code</a>
            <a href="https://justbooks-frontend.onrender.com" className='btn btn-primary' target='blank'>Live Demo</a>
          </div>
        </article>
        
        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={IMG7} alt="" />
          </div>
          <h3>AgroTrade</h3>
          <div className="portfolio__item-cta">
            <a href="https://github.com/TejasPatne/Debug-thugs-31/tree/tejas" className='btn' target='blank'>Code</a>
            <a href="https://github.com/TejasPatne/Debug-thugs-31/tree/tejas" className='btn btn-primary' target='blank'>Live Demo</a>
          </div>
        </article>

        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={IMG3} alt="" />
          </div>
          <h3>Summarize news articles using Python</h3>
          <div className="portfolio__item-cta">
            <a href="https://github.com/TejasPatne/TE-mini-project" className='btn' target='blank'>Code</a>
            <a href="https://github.com" className='btn btn-primary' target='blank'>Live Demo</a>
          </div>
        </article>

        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={IMG6} alt="" />
          </div>
          <h3>Quiz Application in Java</h3>
          <div className="portfolio__item-cta">
            <a href="https://github.com/TejasPatne/Simple-Minds" className='btn' target='blank'>Code</a>
            <a href="https://github.com/TejasPatne/Simple-Minds" className='btn btn-primary' target='blank'>Live Demo</a>
          </div>
        </article>

        {/* <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={IMG7} alt="" />
          </div>
          <h3>AiGyan blog website</h3>
          <div className="portfolio__item-cta">
            <a href="https://github.com/TejasPatne/AIGyan" className='btn' target='blank'>Code</a>
            <a href="https://github.com/TejasPatne/AIGyan" className='btn btn-primary' target='blank'>Live Demo</a>
          </div>
        </article> */}

        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={IMG5} alt="" />
          </div>
          <h3>Zombie Tank vs You</h3>
          <div className="portfolio__item-cta">
            <a href="https://github.com/TejasPatne/Tank-Zombie-vs-Me" className='btn' target='blank'>Code</a>
            <a href="https://tejaspatne.github.io/Tank-Zombie-vs-Me/" className='btn btn-primary' target='blank'>Live Demo</a>
          </div>
        </article>

        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={IMG8} alt="" />
          </div>
          <h3>Weather Prediction</h3>
          <div className="portfolio__item-cta">
            <a href="https://github.com/TejasPatne/Weather-Prediction" className='btn' target='blank'>Code</a>
            <a href="https://tejaspatne.github.io/Weather-Prediction/" className='btn btn-primary' target='blank'>Live Demo</a>
          </div>
        </article>

      </div>
    </section>
  )
}

export default Portfolio